import { useState } from 'react';
import { useAuth } from '../utils/AuthContext';

export default function ForgotPassword() {
    const { requestPasswordReset } = useAuth();
    const [email, setEmail] = useState('');
    const [submitted, setSubmitted] = useState(false);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const handleSubmit = async (event) => {
        event.preventDefault();
        setError('');
        setLoading(true);

        try {
            await requestPasswordReset(email);
            setSubmitted(true);
        } catch {
            setError('Something went wrong.  Please try again.')
        } finally {
            setLoading(false);
        }
    };

    if (submitted) {
        return (
            <div className='max-w-md mx-auto mt-12 text-sm text-gray-700'>
                if an account exists for that email, you'll receive a link to reset your password.
            </div>
        )
    }

    return (
        <div className='min-h-screen flex flex-col bg-gradient-to-br from-slate-50 to-slate-100'>

            {/* forgot pw card  */}
            <div className='flex justify-center items-center px-6 py-24'>
                <div className='w-full max-w-md p-10 rounded-xl shadow-2xl bg-white/90 backdrop-blur-md'>
                <h3 className='text-3xl font-bold text-docpgrPurple mb-8 text-center'>
                    reset password
                </h3>
                    <form onSubmit={handleSubmit} className='space-y-6'>
                        <input type='email' required placeholder='email address' value={email} onChange={(event) => setEmail(event.target.value)} className='w-full p-3 rounded-md border border-gray-300 text-lg focus:outline-none focus:ring-2 focus:ring-docpgrPurple focus:border-docpgrPurple transition' />
                        {error && <p className='text-sm text-red-600'>{error}</p>}
                        <button disabled={loading} className='w-full px-6 py-3 mt-4 rounded-lg text-white font-bold voco-gradient-hover shadow-md hover:shadow-docpgr-purple-glow transition flex items-center justify-center gap-2'>
                            {loading ? ('Sending...') : (<div className='flex items-center gap-2'> <span>send reset link</span> <img src='/assets/invoco_icon_transparent_white.webp' alt='invoco icon' className='h-6 w-6/'/> </div>)}
                        </button>
                    </form>
                </div>
            </div>
        </div>
    )
}